import type { I18n } from '@/typings/i18n'

const fr: I18n = {
  global: {
    indexTitle: 'LOOK',
    tipsTitle: 'Astuce',
    confirmButtonText: 'Confirmer',
    cancelButtonText: 'Annuler',
    day: 'Jour',
    people: 'Personne',
    bindButtonText: 'Lier',
    help: 'Aide',
    manageSubscription: "Gérer l'abonnement",
    coupon: 'Mes Coupons',
    deleteMessage: 'Êtes-vous sûr de vouloir supprimer ?',
    deleteButtonText: 'Supprimer',
    renameButtonText: 'Renommer',
    downloadButtonText: 'Télécharger',
    install: 'installé',
    phoneNumberLabel: 'Numéro de téléphone portable',
    verificationCodeLabel: 'Code de vérification',
    sendButtonText: 'Envoyer',
    saveButtonText: 'Enregistrer',
    download: 'Télécharger',
    complete: 'Terminer',
    adjustButtonText: 'Ajuster',
    eraser: 'Gomme',
    undo: 'Annuler',
    redo: 'Refaire',
    clear: 'Effacer',
    noDataMessage: 'Pas de données',
    loading: 'Chargement en cours',
    customize: 'Personnaliser',
    referenceImage: 'Image de référence',
    styleImage: 'Image de style',
    high: 'Haut',
    middle: 'Moyen',
    low: 'Bas',
    big: 'Grand',
    small: 'Petit',
    select: 'Sélectionner',
    upload: 'Télécharger',
    colon: ':',
    uploadDesc: 'Cliquez ou faites glisser les fichiers dans cette zone pour les télécharger',
    generate: 'Générer',
    preview: 'Aperçu',
    magic: 'Intelligent',
    add: 'Ajouter',
    subtract: 'Réduire',
    brush: 'Pinceau',
    part: 'Partie',
    commonlyUsed: 'Usuel',
    recommend: 'Recommander',
    termsOfService: 'Conditions de service',
    userAgreement: "Accord de l'utilisateur",
    privacyStatement: 'Déclaration de confidentialité',
    wechat: 'WeChat',
    xiaohongshu: 'Xiaohongshu',
    downloadClient: 'télécharger le client',
    ok: "D'accord",
    and: ' et ',
    language: 'Langue',
    copy: 'Copier',
    copyLink: 'Copier le lien',
    signupTitle: "S'inscription",
    signupTitleSuffix: 'LOOK AI Outil de design de mode en temps réel',
    recentsTitle: 'Récemment généré - LOOK',
    projectNameTitle: '{projectName} - LOOK',
    nextStep: 'Étape suivante',
    accept: 'Accepter',
    reject: 'Rejeter',
    about: 'À propos',
    close: 'Fermer',
    skip: 'Sauter',
    iKnow: 'Je sais'
  },
  system: {
    updateTip: 'La nouvelle version a été téléchargée. Cliquez pour mettre à jour.',
    updateMessage: "Êtes-vous sûr de vouloir fermer l'application et installer la mise à jour ?",
    drawingDownMessage: ' nécessite le téléchargement du client.',
    bonjourInstallTitle: 'Bonjour non installé',
    bonjourInstallMessage1: "Le service de réception de projection d'écran n'est pas installé, ",
    bonjourInstallMessage2:
      ' la fonction ne peut pas fonctionner correctement. Veuillez télécharger et installer Bonjour, puis redémarrer LOOK.',
    bonjourInstallMessage3:
      'Si le téléchargement ne fonctionne toujours pas, cliquez sur "Non disponible".',
    bonjourUnavailableTitle: 'Bonjour non installé',
    bonjourUnavailableMessage1:
      "Le service de réception de projection d'écran n'est pas installé, ",
    bonjourUnavailableMessage2: "Veuillez suivre le guide vidéo pour forcer l'installation",
    bonjourUnavailableMessage3:
      "Veuillez réinstaller le service de réception de projection d'écran, puis redémarrer LOOK.",
    bonjourUnavailableMessage4:
      'Si cela ne fonctionne toujours pas après le téléchargement, veuillez visiter notre Discord:',
    bonjourStartTitle: 'Bonjour non démarré correctement',
    bonjourStartMessage1:
      "Le service de réception de projection d'écran n'a pas démarré correctement. La fonction de design en temps réel ne peut pas fonctionner normalement. Veuillez suivre les étapes du guide pour démarrer.",
    bonjourStartMessage2: 'puis',
    bonjourStartMessage3: 'redémarrer LOOK',
    bonjourStartMessage4: '1、Ouvrez les paramètres du système, recherchez "services"',
    bonjourStartMessage5:
      '2、Cliquez avec le bouton droit sur Bonjour dans les services et sélectionnez "Démarrer"',
    bonjourStartMessage6: "3、Reouvrez LOOK pour l'utiliser",
    bonjourStartMessage7:
      'Si cela ne fonctionne toujours pas après le redémarrage, veuillez visiter notre Discord:',
    bonjourStartText: 'démarré correctement',
    bonjourUnavailable: 'la fonction ne peut pas fonctionner correctement',
    bonjourDownload: 'Télécharger Bonjour',
    revoUninstaller: 'Revo Uninstaller',
    forceUninstallMessage:
      "Attention : Si vous avez installé le service de réception de projection d'écran, mais que vous recevez toujours des messages indiquant que le service n'est pas installé, cela peut être dû à une installation incomplète du service. Vous pouvez essayer d'utiliser un outil de désinstallation puissant pour désinstaller les applications Bonjour et Bonjour SDK, puis réessayer d'installer le service de réception de projection d'écran.",
    guideButtonText: 'Tutoriel',
    noImageMessage: 'Aucune image sélectionnée',
    aboutUsTitle: 'À propos de nous',
    weChatPublicAccountTitle: 'Compte officiel WeChat',
    error400: 'Paramètres de demande incorrects',
    error403: 'Accès refusé',
    error404: 'Adresse de la demande introuvable',
    error408: 'Délai de la demande dépassé',
    error500: 'Erreur interne du serveur',
    error501: 'Serveur non implémenté',
    error502: 'Erreur de passerelle',
    error503: 'Service indisponible',
    error504: 'Délai de la passerelle dépassé',
    copySuccess: 'Copie réussie',
    copyError: 'Échec de la copie：',
    browserTips:
      'Pour une meilleure expérience utilisateur, veuillez utiliser le navigateur Chrome pour accéder ou ',
    serviceStopMessage:
      "Votre abonnement Pro n'a pas été automatiquement renouvelé le {date}. Si vous ne payez pas avant la date limite, le service sera interrompu.",
    renewalReminderMessage: "Si vous avez besoin de continuer à l'utiliser, veuillez",
    paymentLink: "cliquez pour compléter le paiement de l'abonnement",
    updateTipsMessage:
      'LOOK a détecté une nouvelle version et va se fermer automatiquement pour installer la mise à jour.',
    osVersionNotSupportedMessageWindows:
      "Les versions du système d'exploitation inférieures à Windows 10 64 bits ne sont pas prises en charge, ce qui peut affecter votre expérience utilisateur. Il est recommandé de mettre à niveau votre système d'exploitation ou d'accéder via un navigateur.",
    osVersionNotSupportedMessageMacOS:
      "Les versions du système d'exploitation inférieures à Mac OS 13 ne sont pas prises en charge, ce qui peut affecter votre expérience utilisateur. Il est recommandé de mettre à niveau votre système d'exploitation ou d'accéder via un navigateur.",
    updatedDownloadMessage:
      'LOOK a détecté une nouvelle version et va se fermer automatiquement pour installer la mise à jour.',
    receiverConnectErrorMessage:
      "Erreur de connexion du récepteur de projection d'écran :{message}",
    receiverStartErrorMessage: "Erreur de démarrage du récepteur de projection d'écran :{message}",
    macOSVersionErrorMessage:
      "Erreur de démarrage du récepteur de projection d'écran : la version de Mac OS est trop ancienne, veuillez mettre à niveau votre système d'exploitation.",
    airplayRTPErrorMessage:
      'AirPlay a rencontré une erreur réseau lors de la projection. Veuillez vérifier votre connexion réseau, puis essayer de redémarrer LOOK.',
    networkDisconnectedMessage:
      'La connexion réseau a été perdue, la projection a été arrêtée. Veuillez vérifier votre connexion réseau.',
    networkReconnectedMessage:
      'Le réseau a été reconnecté. Pour continuer la diffusion, veuillez redémarrer LOOK et reconnecter votre appareil.',
    slogan1: 'Outil de design de mode en temps réel par IA',
    slogan2: 'Présentez vos idées en temps réel !',
    slogan3: 'Design en temps réel, résultats réels',
    slogan4: 'Transformez instantanément des croquis en rendus, générez plusieurs variantes',
    slogan5: "Fusion de styles : Dépassez les limites de l'imagination",
    slogan6: "Ajustements partiels : Contrôle précis avec l'IA",
    networkErrorMessage:
      "Le réseau n'est actuellement pas connecté. Veuillez vérifier les paramètres réseau de votre appareil.",
    serverErrorMessage: 'La connexion au serveur a échoué. Veuillez réessayer plus tard.',
    languageChangeMessage:
      'Passer à cette langue nécessite une reconnexion. Êtes-vous sûr de vouloir changer ?',
    downloadAppMessage:
      'Téléchargez et connectez-vous à l\'application pour la première fois pour obtenir <br/><span style="font-weight: 700; font-size: 24px">1 JOUR SUPPLÉMENTAIRE d\'essai gratuit</span>',
    downloadButtonTextMac: 'Télécharger pour macOS',
    downloadButtonTextWindows: 'Télécharger pour Windows',
    consentTitle: 'Avis sur les cookies',
    consentTips:
      'Afin de vous fournir un meilleur service et une expérience personnalisée, nous utilisons des cookies et des technologies similaires pour analyser les performances du site web, afficher des publicités personnalisées et fournir des fonctionnalités de médias sociaux. En cliquant sur "Accepter tous les cookies" ou en continuant à utiliser ce site, vous acceptez l\'utilisation de cookies d\'analyse et de suivi qui nous permettent de vous offrir une expérience plus personnalisée. Consultez notre <span style="font-weight: 700; text-decoration: underline; cursor: pointer">Politique de cookies</span> pour en savoir plus sur les cookies que nous utilisons.',
    aboutTitle: 'Application de bureau LOOK',
    currentVersion: 'Version',
    newVersion: 'Nouvelle version',
    copyright: 'Copyright © 2024 LOOK AI LIMITED',
    checkUpdateButtonText: 'Vérifier les mises à jour',
    updateButtonText: 'Mettre à jour vers {version}',
    noUpdateMessage: 'Version à jour',
    updateFailMessage:
      'Mise à jour échouée, LOOK tentera de mettre à jour à nouveau après le redémarrage',
    appDownloadGuideTitle: 'Télécharger le client LOOK pour ordinateur',
    appDownloadGuideSubTitle:
      'Cette fonctionnalité nécessite le téléchargement du client LOOK pour ordinateur.',
    realtimeDesignGuideTitle: 'Guide de Real-Time Design',
    realtimeDesignGuideSubTitle1:
      'La fonction de Real-Time Design nécessite le téléchargement du <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> client LOOK pour ordinateur et son utilisation synchronisée avec l\'application <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> Procreate.',
    realtimeDesignGuideSubTitle2:
      'Veuillez ouvrir <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> Procreate et le <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> client LOOK pour ordinateur, puis suivez le guide pour établir la connexion de projection d\'écran.',
    freeCountLimitDialogTitle: 'Limite de génération atteinte ?',
    freeCountLimitDialogDesc:
      'Téléchargez et connectez-vous à l\'application pour la première fois pour obtenir <br/><span style="font-weight: 600; font-size: 24px">1 JOUR SUPPLÉMENTAIRE d\'essai gratuit</span>',
    freeCountLimitDialogDescMobile:
      'Téléchargez et connectez-vous à l\'application sur<br/><span style="font-weight: 600">PC ou macOS</span> pour obtenir <br/><span style="font-weight: 600;font-size: 24px">1 JOUR SUPPLÉMENTAIRE d\'essai gratuit</span>',
    imageSizeTooLarge: "La taille de l'image ne peut pas être supérieure à {size}MB"
  },
  error: {
    invitationCodeUsed: "Le code d'invitation a déjà été utilisé",
    invitationCodeInvalid: "Le code d'invitation est invalide",
    networkErrorTitle: 'Erreur réseau',
    networkErrorMessage:
      'Impossible de se connecter au serveur. Veuillez vérifier votre connexion réseau et réessayer',
    retryButtonText: 'Réessayer',
    upscaleScaleError:
      "Upscale n'est pas autorisé. Veuillez mettre à niveau votre abonnement pour débloquer une meilleure qualité d'image.",
    campaignSystemError: 'Erreur système, veuillez réessayer plus tard',
    campaignUserAuthError: "Échec de l'obtention de l'identité de l'utilisateur",
    campaignParamError: 'Erreur de paramètre',
    campaignQueryError: 'Erreur de requête',
    campaignNotCompleted: 'Tâche de campagne non terminée',
    campaignRewardAlreadyClaimed: 'Récompense déjà réclamée',
    campaignCouponNotAvailable: 'Coupon non disponible',
    campaignUseCoupon: "Échec de l'utilisation du coupon",
    campaignAssignCoupon: "Échec de l'attribution du coupon",
    userGoogleAuthFail: 'Échec de la connexion Google',
    userNotSupportLoginType: 'Type de connexion non supporté',
    userSystemError: 'Erreur système',
    userLoginError: 'Échec de la connexion'
  },
  account: {
    logoutMessage: 'Êtes-vous sûr de vouloir vous déconnecter ?\n',
    logoutButtonText: 'Déconnexion',
    bindPhoneTitle: 'Lier le téléphone mobile',
    bindPhoneSuccessMessage: 'Liaison du téléphone mobile réussie',
    bindPhoneTips: 'Liez votre numéro de téléphone pour obtenir un abonnement gratuit',
    bindPhoneEmptyNumberMessage: 'Veuillez entrer votre numéro de téléphone portable',
    bindPhoneErrorNumberMessage: "Ce n'est pas un numéro de téléphone portable valide",
    bindPhoneVerificationCodeEmptyMessage: 'Veuillez entrer le code de vérification\n',
    getInvitationCodeErrorMessage: "Échec de la récupération des informations du code d'invitation",
    trialDuration: 'Essai gratuit : ',
    headerGiftText: 'Obtenir un coupon',
    headerOneDayGiftText: 'Abonnement à -{discount}%',
    headerSubscribeGiftText: 'Abonnez-vous maintenant',
    invitePopoverTitle: 'Inviter des amis',
    invitePopoverDescTips:
      'Les nouveaux utilisateurs liant leur téléphone mobile sont considérés comme ayant invité avec succès un nouvel utilisateur',
    invitePopoverMark: 'Réclamez&nbsp;<span>15 $US</span>&nbsp;de bon!',
    invitePopoverDesc:
      "Pour chaque ami que vous invitez, vous recevrez un bon de 15 $US pouvant être utilisé pour l'abonnement/renouvellement ! Votre ami bénéficiera d'un essai gratuit de 15 jours !",
    invitePopoverCodeShareTitle: 'Scanner pour Partager',
    invitePopoverCodeCopyTitle: "Cliquez pour copier le code d'invitation",
    invitePopoverShareCountText: 'Invitations Restantes :',
    invitePopoverSubText:
      "Le nombre de codes d'invitation est attribué automatiquement en fonction de l'utilisation.",
    invitePopoverGiftDaysText: 'Bons accumulés :',
    invitePopoverBindPhoneMaskText:
      "Liez votre téléphone portable pour activer et recevoir des places d'invitation",
    phoneNumber: 'Numéro de téléphone :',
    noMemberText: 'Free',
    memberExpireAtFormat: 'DD/MM/YYYY',
    memberExpireAt: "Date d'expiration :",
    memberUpgradeMainText:
      'Déverrouiller des limites de génération plus élevées pour les images 4K',
    memberUpgradeMainTextFirst: 'Obtenez -50% !',
    memberUpgradeSubText: 'Réalisez la liberté de conception en temps réel !',
    memberUpgradeLinkTextActivate: 'ACTIVER',
    memberUpgradeLinkTextUpgrade: 'METTRE',
    memberUpgradeLinkTextGet: 'OBTENIR',
    memberUpgradeLinkTextManage: 'GÉRER',
    discordLoginTitle: 'Commencer avec LOOK',
    discordLoginButtonText: 'Continuer avec Discord',
    discordLoginSubText1: 'En vous inscrivant, vous créez un compte LOOK AI et acceptez les ',
    discordLoginSubText2: ' de LOOK AI.',
    googleLoginButtonText: 'Continuer avec Google',
    invitePageTitle: 'Bonjour, designer',
    invitePageNicknamePlaceholder: 'Surnom',
    invitePageInvitationCodePlaceholder: "Code d'invitation",
    invitePageSubmitButtonText: 'Commencer à utiliser',
    invitePageTips:
      '<span style="font-weight: 700">8 JOURS GRATUITS</span> avec code d\'invitation',
    invitePageInvitationCodeInvalid: "Code d'invitation non valide",
    hasInvitationCodeText: "J'ai un code d'invitation",
    shareInvitationCodeText: `Outil de Design de Mode en Temps Réel LOOK AI

💻 Accès PC : https://app.lookfashion.ai
📱 Actuellement non supporté sur mobile

Code d'invitation : {code}`,
    limitedTitle: 'Ralentis…',
    limitedSubject:
      'Vous avez atteint la limite de génération pour <span style="font-weight: 600">{name}</span>,',
    limitedTime: 'Vous pouvez continuer à utiliser après {time}.',
    limitedRealtimeDesignTime:
      'Veuillez continuer à utiliser dans la prochaine période de souscription.',
    upgradeTitle: "Fatigué d'attendre ?",
    upgradeSubject:
      'Mettez à niveau votre abonnement pour <span style="font-weight: 600">générer immédiatement</span>!',
    upgradeButtonText: 'Mettez à niveau',
    mergeAccount: "C'est vous ?",
    mergeAccountDesc: 'Oui, lier mon compte',
    mergeAccountCancel: 'Non, retourner à la connexion',
    recentLoginText: 'Dernière fois'
  },
  project: {
    recentListTitle: 'Récemment généré',
    collectListTitle: 'Liste des favoris',
    projectListTitle: 'Liste des Projets',
    emptyMessage1: 'Aucun projet créé pour le moment',
    emptyMessage2: 'Cliquez ci-dessous pour créer un projet',
    emptyMessage3: 'Commencer à générer',
    emptyMessage4: 'Aucune image enregistrée pour le moment, générez et ',
    emptyMessage5: 'enregistrer pour ajouter des images',
    emptyMessage6: "Créez d'abord un nouveau projet, puis générez dans le projet et ",
    emptyMessage7: 'enregistrer LOOK',
    createProjectButtonText: 'Nouveau projet',
    projectNamePlaceholder: 'Veuillez entrer le nom du projet',
    projectEnterText1: 'Entrer dans le projet',
    projectEnterText2: "Entrer dans l'atelier",
    createProjectTip: "Veuillez créer un projet d'abord"
  },
  image: {
    text2ImageTitle: 'Texte vers Image',
    originalityTitle: 'Croquis vers Image',
    styleExtensionTitle: 'Extension de Style',
    styleFuseTitle: 'Fusion de Styles',
    tuneTitle: 'Ajustement de Zone',
    recolorTitle: 'Recoloration Intelligente',
    backgroundTitle: 'Changement de Scène AI',
    eraserTitle: 'Effacement magique',
    cutoutTitle: 'Détourage en Un Clic',
    flowerPatternExpansionTitle: 'Carreau sans couture',
    aiExpansionTitle: 'Extension AI',
    hdTitle: 'Super Résolution',
    drawingTitle: 'Real-Time Design',
    patternTitle: 'Cartographie des motifs',
    imageCount: '',
    generateButtonText: 'Générer LOOK',
    generateButtonSubscribeBoxTitle1: '50% de réduction pour les premiers abonnés',
    generateButtonSubscribeBoxTitle2: 'Déverrouiller la version pro',
    generateButtonSubscribeBoxDesc1:
      'Essai gratuit expiré ? Débloquez plus de privilèges de génération maintenant avec une réduction !',
    generateButtonSubscribeBoxDesc2:
      'Passez à la version Pro pour atteindre la liberté de Real-Time Design !',
    generateButtonSubscribeBoxButtonText1: 'Essai gratuit',
    generateButtonSubscribeBoxButtonText2: 'Passer à la version Pro',
    originalSizeText: 'Ratio',
    uploadImageButtonText: "Télécharger l'image Veuillez",
    uploadPatternButtonText: 'Télécharger le motif',
    editMaskButtonText: 'Modifier le masque',
    removeMaskButtonText: 'Supprimer le masque',
    imageUploaderDesc:
      '<span style="color: #4c4c4c; font-size: 14px">Cliquez ou faites glisser pour télécharger</span><br/> <span style="color: #b0b2ae; font-size: 12px">(Les images dans la zone de sauvegarde ci-dessous et à droite peuvent être glissées directement)</span>',
    generatePreviewText: 'Générer un aperçu({count}/{max})',
    previewListHelpMessage1:
      "Les images générées sont temporairement stockées dans cette liste, jusqu'à {max} images. Lorsqu'il dépasse {max} images, la première image générée sera supprimée.",
    previewListHelpMessage2:
      "Les images temporaires doivent être sauvegardées dans l'album pour être conservées et effectuer plus d'actions.",
    clearPreviewButtonText: 'Effacer tous les aperçus',
    segmentErrorMessage: "L'analyse sémantique de l'image a échoué, veuillez réessayer",
    generatingMessage: "Génération d'images en cours",
    previewWaitingMessage: "Traitement de l'image en cours, veuillez patienter",
    previewFailedMessage: "Échec du traitement de l'image, impossible de voir",
    imageInQueueMessage: 'En attente',
    imageNotVerifyMessage: 'Violation',
    saveImageButtonText: "Enregistrer dans l'album",
    deleteTmpImageButtonText: 'Supprimer les images temporaires',
    previewImageInfoText: "Informations sur l'image",
    promptDefaultPlaceholder:
      'Entrez une description du design ou des mots de description pour améliorer la précision de la génération',
    promptDefaultPlaceholder2: 'Entrez une description du motif',
    promptDefaultPlaceholder3: "Entrez une description de l'image",
    promptDefaultPlaceholder4: 'Entrez une description du modèle',
    removeBgErrorMessage: "Échec de la suppression de l'arrière-plan",
    removeBgButtonText: "Supprimer l'arrière-plan",
    removeBgLoadingMessage: "Suppression de l'arrière-plan en cours, veuillez patienter",
    cropTip1:
      "Essayez de laisser suffisamment d'espace en haut et en bas de l'image pour générer la tête et les jambes du modèle",
    cropTip2:
      "Si l'image téléchargée est trop petite, veuillez la recadrer à une taille appropriée",
    diyModelText: 'Modèle personnalisé',
    commonModelText: 'Modèle public',
    exclusiveModelText: 'Modèle exclusif',
    promptTitle: 'Caractéristiques du design',
    promptTitle2: 'Description du motif',
    promptTitle3: "Description de l'image",
    promptTitle4: 'Description du modèle',
    promptInputTitle: 'Caractéristiques de design (multi-sélection)',
    selectModelTitle: 'Sélection de modèle',
    referenceStrengthLabel: 'Intensité de référence',
    modelSettingTitle: 'Paramètres du modèle',
    advancedSettingsTitle: 'Paramètres avancés',
    negativePromptTitle: 'Invite négatif',
    negativePromptPlaceholder:
      "Entrez ou sélectionnez les éléments que vous ne souhaitez pas voir dans l'image",
    generateCountTitle: 'Taille de Lot',
    cleanerTitle: 'Supprimer le premier plan',
    maskSwitchViewButtonText: 'Changer de vue',
    regenerateButtonText: 'Régénérer',
    imageLoadingMessage: "Chargement de l'image",
    maskGenerateFailedMessage: 'Échec de la création du masque',
    maskPreviewDialogConfirmButtonText1: 'Confirmer le détourage',
    maskPreviewDialogConfirmButtonText2: 'Créer un masque',
    maskPreviewDialogCancelButtonText: 'Continuer à modifier',
    objectRemovalDialogCancelButtonText: 'Continuer à modifier',
    objectRemovalFailedMessage: 'Échec de la suppression du premier plan',
    magicMaskGenerateFailedMessage: 'Échec de la création du masque intelligent',
    partMaskDialogTitle: 'Sélection partielle',
    imageAnalyzingMessage: "Analyse de l'image en cours",
    cutout: 'Détourage',
    maskDialogConfirmButtonText1: "Préparation de l'aperçu en cours",
    maskDialogConfirmButtonText2: "Générer l'aperçu",
    maskDialogConfirmTip: 'Bloqué ? Réessayez !',
    rangeOfChangeLabel: 'Niveau de modification',
    lesser: 'Variation petite',
    more: 'Variation grande',
    disableModelDesc:
      "Désactiver le modèle, veuillez vous assurer qu'il n'y a pas de modèle dans le croquis",
    generateFailedMessage: "Échec de la création de la tâche de génération d'image",
    taskNotEnoughTip:
      'Le nombre maximum de tâches de génération simultanées a été atteint. Veuillez réessayer plus tard.',
    saveTip1:
      "Enregistrer {saveType} signifie qu'après avoir enregistré l'image, l'opération d'amélioration de la clarté sera automatiquement effectuée.",
    saveTip2:
      "Si le nombre total de tâches LOOK et {saveType} en cours a atteint le nombre maximum de tâches simultanées, l'enregistrement de l'opération {saveType} sera temporairement indisponible.",
    promptButtonText1: 'AI Retouche',
    promptButtonText2: "Description d'image",
    promptButtonMessage: "Veuillez d'abord entrer un prompt",
    promptButtonFailMessage: 'Échec de génération, veuillez réessayer',
    colorMatchTitle: 'Correspondance de couleur',
    colorMatchSubject: 'Illustration de mode en photo',
    colorMatchDesc: 'Présente la vraie couleur et la texture du tissu',
    patternExpansionSize: "Taille de l'expansion",
    patternExpansionSizeSmall: 'Petite',
    patternExpansionSizeMedium: 'Moyenne',
    patternExpansionSizeLarge: 'Grande',
    flowerPatternExpansionStep1: '1.Télécharger un motif non continu',
    flowerPatternExpansionStep2: '2.Sélectionnez la zone à étendre',
    flowerPatternExpansionStep3:
      '3.LOOK génère les bords du motif, transformant le motif original en un motif continu. Il peut être enregistré ou téléchargé pour une utilisation future.',
    maskCreateText: 'Créer un masque'
  },
  cleaner: {
    maskDialogTitle: 'Sélectionnez la zone à effacer',
    maskDesc: 'Sélectionnez la zone à effacer'
  },
  drawing: {
    generatingMessage: 'Génération en cours, veuillez patienter',
    startDrawingMessage: 'Veuillez commencer à dessiner',
    waitingScreenMessage: "En attente de projection d'écran...",
    canvasCropperGuideMessage: "Veuillez recadrer l'écran à la taille de la toile sur LOOK",
    startDrawingButtonText: 'Commencer la conception',
    stopDrawingButtonText: 'Cliquez pour arrêter',
    videoNotSupportMessage: 'Le navigateur actuel ne supporte pas la lecture vidéo',
    canvasGuideMessage1:
      'Lancez <img src="{image}" width="26" height="26" /> Procreate et désactivez/réactivez la <span style="font-weight: 700; text-decoration: underline">Diffusion de la toile</span>',
    canvasGuideMessage2:
      'La Diffusion de la toile doit être désactivée puis réactivée pour un bon fonctionnement',
    castScreenGuideMessage1: 'La version actuelle ne prend en charge que',
    castScreenGuideMessage2: " Procreate projection d'écran",
    castScreenGuideMessage2After: '',
    castScreenGuideMessage3:
      "Suivez le guide pour ouvrir la connexion de mise en miroir de l'écran de l'iPad {placeholder}",
    castScreenGuideMessage4: '(Les deux appareils doivent être sur le même réseau)',
    screenPreviewTitle: 'Aperçu de la projection',
    reCropButtonText: 'Recadrer à nouveau'
  },
  hd: {
    scaleTitle: "Améliorer la qualité de l'image",
    imageClaritySD: 'Enregistrer',
    imageClarityHD: 'Enregistrer en HD',
    imageClarityUHD: 'Enregistrer en UHD',
    imageClarityTextSD: 'SD',
    imageClarityTextHD: 'HD',
    imageClarityTextUHD: 'UHD',
    generatingMessage: ' Agrandissement en cours'
  },
  matte: {
    maskDialogTitle: 'Sélectionner la zone à conserver',
    maskDesc: 'Sélectionnez la zone à conserver',
    magicLabel: 'Détourage intelligent'
  },
  originality: {
    lineDrawingTitle: 'Esquisse',
    lineDrawingUploadTitle: 'Téléchargement du croquis',
    sampleClothesTitle: "Vêtement d'échantillon"
  },
  recolor: {
    maskDialogTitle: 'Sélectionner la zone à changer de couleur',
    maskDesc: 'Veuillez sélectionner la zone à changer de couleur',
    colorSelectTitle: 'Sélection des couleurs',
    getColorWarningMessage: 'Le navigateur actuel ne prend pas en charge la fonction pipette'
  },
  styleFusion: {
    referenceImageDialogTitle1: 'Croquis de style'
  },
  background: {
    maskDialogTitle: 'Sélectionner la zone à conserver',
    maskDesc: 'Sélectionnez la zone à conserver',
    backgroundDialogTitle: 'Ajouter un arrière-plan',
    backgroundDescTitle: "Description de l'arrière-plan",
    promptInputPlaceholder:
      "Entrez une description de l'arrière-plan pour améliorer la précision de génération",
    referenceBackgroundTitle: 'Arrière-plan de référence',
    intelligentFillLightLabel: 'Éclairage intelligent',
    backgroundGenerateTimeoutMessage:
      "Délai de génération de l'arrière-plan dépassé, veuillez réessayer",
    backgroundGenerateFailedMessage:
      "Échec de la génération de l'arrière-plan, veuillez réessayer\n",
    addBackgroundTitle: 'Ajouter un arrière-plan',
    backgroundSizeTitle: "Taille de l'arrière-plan",
    effectPreviewMessage: 'Aperçu des effets',
    canvasEmptyMessage: "Veuillez ajouter un arrière-plan d'abord"
  },
  text2Image: {
    textExampleMessage1:
      "Une photo de lookbook d'un mannequin italien portant un pull en tricot oversize, avec un gros plan sur la personne. Le vêtement est un pull en tricot à carreaux composé de fils de différentes couleurs, représentant la mode extérieure et streetwear d'une marque de mode. Photographié dans le style de Campbell Addy, c'est une photo éditoriale de haute couture.",
    textExampleMessage2:
      "Un mannequin chinois à la mode portant une longue robe fluide dans un style chinois moderne. La tenue présente des couleurs à faible saturation et des imprimés assortis. C'est un look de défilé de la Shanghai Fashion Week, mettant en avant un sens moderne de la mode.",
    textExampleMessage3:
      "Un gros plan d'un mannequin de mode, avec un vêtement présentant des divisions structurelles, une tenue moderne, simple, propre et fluide. L'ensemble est un mélange de soie et de lin, idéal pour une couverture de magazine de mode.",
    textExampleMessage4:
      "Un mannequin à la mode porte une chemise blanche avec une broderie exquise. La chemise est ornée de motifs floraux rouge foncé et de détails de broderie dorée, ajoutant une touche d'élégance vintage. Le mannequin porte une paire de boucles d'oreilles rondes en or, les cheveux soigneusement coiffés vers l'arrière, révélant son visage. Le fond vert foncé met en valeur le teint et la tenue du mannequin, donnant à l'image globale une forte dimension artistique. La photo est dans des tons doux, avec une faible saturation, créant une atmosphère sereine et poétique.",
    textExampleMessage5:
      "Un mannequin de mode en solo, portant un pull ample orange vif en tricot épais, avec un col haut et des manches légèrement larges. Le bas est une jupe en cuir bleu foncé de style A avec une finition brillante et une texture ferme. Le mannequin porte des talons hauts avec des semelles épaisses, ajoutant une sensation de lourdeur. Les lunettes de soleil à monture orange et verres bleus complètent le look, donnant à l'ensemble une touche futuriste et dramatique. L'ensemble utilise des couleurs à haute saturation avec des contrastes forts, créant un effet visuel frappant et audacieux. Les accessoires et le maquillage sont uniques et exagérés, soulignant la personnalisation et l'art. Le fond est simple.",
    textExampleMessage6:
      'Une jeune femme à la mode portant une veste fluorescente jaune, debout dans une rue au Japon, ciel bleu, lumière naturelle, photo du haut du corps',
    textExampleMessage7:
      'Un mannequin féminin blanc élégant portant un long manteau minimaliste à col en V gris foncé et des bottes Martin, photographié dans le style de Theo Angelopoulos. Le manteau est fabriqué en tissu de cachemire de la marque Lemaire, avec des plis et une patte de boutonnage croisée, dégageant une atmosphère sereine et sacrée. La scène se déroule dans une forêt brumeuse.',
    textExampleMessage8:
      "Une femme à la mode portant un pull en tricot vert audacieux avec un fond violet. Le pull présente un design unique avec des éléments blancs et bleus, ressemblant à des visages abstraits. Le tissu semble être un tricot épais, probablement en laine ou en mélange de laine, couramment utilisé dans ce type de vêtement pour la chaleur et la texture. La coupe est ample, avec des manches qui s'étendent au-delà des poignets, décontractée et oversize. Le vert vibrant domine l'ensemble du look, contrastant avec un pantalon noir pour créer une combinaison de couleurs accrocheuse. Le style global est avant-gardiste et s'inscrit dans la mode de rue contemporaine.",
    textExampleMessage9:
      'Une influenceuse de mode coréenne porte une chemise en jean bleu clair ample avec des manches larges. La chemise semble avoir été délavée, avec plusieurs déchirures et zones décolorées, indiquant un style vintage. Le mannequin porte également un short de couleur claire, peut-être en denim, assorti à la chemise. Elle a de longs cheveux noirs lisses, une expression neutre, et regarde droit devant elle. Le fond est gris clair, mettant en valeur la tenue. Texture de film.',
    textExampleMessage10:
      "Un mannequin coréen se tient devant un fond minimaliste. Elle porte un grand cardigan tricoté vert olive clair avec une capuche, qui semble très confortable et décontracté. Le cardigan est en tissu tricoté épais et présente un motif géométrique tridimensionnel. La coupe est ample, adaptée aux tenues d'automne ou d'hiver. Le mannequin porte également une casquette de baseball marron foncé, avec le logo de la casquette clairement visible. Son expression est neutre, et son regard est dirigé sur le côté, dégageant une ambiance détendue et décontractée. Le style général penche vers le décontracté et le mode, en mettant l'accent sur le confort et la modernité. La photo a une texture semblable à celle d'un film.",
    textExampleMessage11:
      "Un mannequin se tient devant un fond neutre. Elle porte une tenue unique de couleur ivoire avec des manches larges et un ourlet asymétrique, présentant plusieurs couches de tissu empilées dans un style rappelant les vêtements traditionnels chinois. Le tissu est doux et fluide, avec une certaine texture, probablement en coton léger ou en mélange de soie. La coupe est ample, offrant un look moderne à la fois confortable et élégant. La tenue est principalement ivoire, avec un pantalon noir pour offrir un contraste. Le style général penche vers le minimalisme avec une touche d'élégance. Le mannequin a une apparence soignée, avec une coiffure simple et une expression calme, ajoutant une impression de sérénité et de confiance à l'ensemble du look.",
    generationRatioTitle: "Rapport d'image",
    tryText: 'Essayez',
    freeProportionText: 'libre'
  },
  tune: {
    maskDialogTitle: 'Sélectionner la zone à modifier',
    maskDesc: 'sélectionner la zone à modifier',
    promptTitle: 'Invite'
  },
  pattern: {
    maskDialogTitle: 'Sélectionner la zone à modifier',
    maskDesc: 'sélectionner la zone à modifier',
    assistImagesTitle: 'Pattes'
  },
  modelTryOn: {
    modelImageDialogTitle1: 'Télécharger le modèle',
    modelImageDialogTitle2: 'Télécharger le vêtement',
    maskDesc: 'Sélectionner la zone à changer de vêtement',
    maskDialogTitle: 'Sélectionner la zone à changer de vêtement',
    upperBodyTitle: 'Haut/Vêtement',
    dressTitle: 'Bas/Vêtement',
    loadingText: 'Sélection intelligente en cours, veuillez patienter...',
    errorText: 'Sélection intelligente échouée, veuillez réessayer',
    upperBodyMaskDialogTitle: 'Sélectionner la zone du haut/vêtement',
    dressMaskDialogTitle: 'Sélectionner la zone du bas/vêtement',
    singleMaskDialogTitle: 'Sélectionner la zone du modèle',
    single: 'Article unique',
    multi: 'Article multiple',
    singleTitle: 'Article unique'
  },
  modelFace: {
    uploadImageTitle: 'Télécharger l\'image originale',
    maskDialogTitle: 'Peindre la zone du visage de la personne',
    maskDesc: 'Veuillez peindre la zone du visage de la personne',
    selectModelTitle: 'Télécharger le modèle',
    modelSelectorDesc: '<span style="color: #4c4c4c; font-size: 14px">Cliquez pour sélectionner le modèle</span>',
    headSize: 'Taille de la tête'
  },
  diyModel: {
    sex: 'Sexe',
    male: 'Homme',
    female: 'Femme',
    age: 'Âge',
    kid: '5',
    juvenile: '15',
    adult: '25',
    youth: '35',
    middleAged: '50',
    elderly: '60',
    color: 'Couleur de peau',
    bodyShape: 'Morphologie',
    hair: 'Cheveux',
    length: 'Longueur',
    hairstyle: 'Coiffure',
    slenderBody: 'Corps mince',
    hourglassBody: 'Corps équilibré',
    muscularBody: 'Musclé',
    babyFatBody: 'Joufflu',
    shortAndFatBody: 'Petit et gros',
    curvaceousBody: 'Corps avec courbes',
    straight: 'Cheveux raides',
    wavy: 'Cheveux ondulés',
    curly: 'Cheveux bouclés',
    braided: 'Cheveux tressés',
    naturallyCurly: 'Cheveux naturels',
    updo: 'Cheveux relevés',
    airBangs: 'Frange aérienne',
    dreadlocks: 'Tresses africaines',
    ponytail: 'Queue de cheval',
    bald: 'Crâne rasé',
    centerPartedHair: 'Cheveux séparés au milieu',
    bangs: 'Frange droite',
    frontBangs: 'Mèche frontale',
    short: 'Cheveux courts',
    long: 'Cheveux longs',
    shoulderLength: 'Cheveux mi-longs',
    extraLongHair: 'Cheveux très longs',
    pixieCut: 'Cheveux courts aux oreilles',
    collarboneLengthHair: 'Cheveux aux épaules',
    shoulderLengthHair: 'Cheveux au-dessus des épaules',
    waistLengthHair: "Cheveux jusqu'à la taille",
    fairSkinWhite: 'Teint clair',
    darkSkin: 'Teint foncé',
    yellowSkin: 'Peau jaune',
    asian: 'Asiatique',
    european: 'Européen',
    african: 'Africain',
    american: 'Américain',
    middleEastern: 'Middle-eastern'
  },
  maskDialogHelpTip: {
    mask: 'Cliquez avec la souris pour sélectionner la zone à conserver',
    matte:
      "Téléchargez une image, cliquez avec la souris pour sélectionner la zone à conserver. Si aucun détourage n'est nécessaire, cliquez directement sur le bouton de confirmation.",
    cutout: 'Cliquez avec la souris pour sélectionner la zone à conserver',
    part: 'Cliquez avec la souris pour sélectionner la zone à utiliser comme masque',
    objectRemoval:
      'Pour supprimer une partie du premier plan, cliquez sur "Supprimer le premier plan", puis cliquez avec la souris sur la zone à supprimer. Si ce n\'est pas nécessaire, cliquez directement sur le bouton "Confirmer".'
  },
  subscribe: {
    subscribeTitle:
      'Premier abonnement spécial&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">{discount}% OFF</span>&nbsp;de réduction',
    subscribeTitleFree:
      'Premier abonnement vous offre&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">7 jours d\'adhésion gratuite</span>',
    person: 'Personne',
    month: 'Mois',
    year: 'Année',
    currency: '$US',
    mostPopularText: 'Populaire',
    noMemberText: 'Aucun abonnement',
    subscribeSubText:
      'Renouvellement automatique après expiration de l\'abonnement, <span style="color: #0d0d0d">retour au prix normal le mois suivant</span>, résiliable à tout moment',
    subscribeSubTextFree:
      'Les abonnements peuvent être annulés à tout moment sans frais supplémentaires',
    priceNegotiableText: 'Contact Ventes',
    tryThisText: 'Le plus populaire',
    payButtonText1: "S'abonner",
    payButtonText1Free: "0.00$US Obtenez 7 jours d'adhésion gratuite !",
    payButtonText2: "S'abonner",
    payButtonText3: 'Actualiser le plan',
    payButtonText4: 'Abonnement actuel',
    payButtonText5: 'Service Client',
    payButtonText6: 'Modifier facture',
    payButtonText7: "S'abonner",
    payMessage1: " est le plan après la fin de l'essai gratuit",
    payMessage2: "En cours d'activation",
    payMessage3: "Paiement après la fin de l'essai de 15 jours",
    payMessage4: 'Payer',
    payMessage5: 'Veuillez scanner le QR code pour compléter le paiement',
    payMessage6:
      "Renouvellement automatique à {currency}{amount}/mois à l'expiration, annulable à tout moment",
    payMessage7:
      "À l'expiration de l'essai, renouvellement automatique à {currency}{amount}/mois, annulable à tout moment",
    payMessage8: 'Veuillez scanner le code QR pour finaliser la signature',
    paySuccessText: 'Abonnement réussi',
    paySubText: "L'activation signifie accord",
    freeMemberSuccessDesc:
      "Les frais seront déduits après la fin de la période d'essai de 15 jours. L'abonnement peut être annulé à tout moment sans frais supplémentaires.",
    receiveAwardTitle: '🎉Bienvenue sur LOOK',
    receiveAwardTitleTaskGuide: "🎉1 jour d'essai gratuit reçu !",
    receiveAwardSubject:
      'Nous avons préparé pour vous<br><span style="font-size: 24px; font-weight: 700">{number} jours d\'essai gratuit</span>',
    receiveAwardSubjectTaskGuide:
      'Découvrez facilement les fonctionnalités principales de LOOK',
    receiveAwardTip: 'Pas assez ?',
    receiveAwardButtonTextTaskGuide: 'Commencer',
    receiveAwardButtonText: 'Essai gratuit de {number} jours pour {currency}0,00',
    memberInvitedOnly: 'Sur invitation',
    memberTipsStarter: "Parfait pour les designers individuels et les nouveaux venus dans l'IA. ",
    memberTipsPlus: "Pour les designers expérimentés ayant besoin d'outils d'IA avancés. ",
    memberTipsPro: "Pour les professionnels recherchant la puissance totale de l'IA.",
    memberFreeDesc1Label: 'Images générées',
    memberFreeDesc1Value: '8 images/jour',
    memberFreeDesc2Label: 'Résolution',
    memberFreeDesc2Value: 'Standard',
    memberFreeDesc3Label: 'Tâches simultanées',
    memberFreeDesc3Value: '2',
    memberFreeDesc4Label: 'Real-Time Design',
    memberFreeDesc4Value: 'Non',
    memberDescStarter0Label: 'Générations',
    memberDescStarter0Value: 'Illimité',
    memberDescStarter1Label: 'Vitesse de génération',
    memberDescStarter1Value: 'Normal',
    memberDescStarter2Label: 'Générations simultanées',
    memberDescStarter2Value: '{count}',
    memberDescStarter3Label: 'Fréquence de génération',
    memberDescStarter3Value: '50 / 4 h',
    memberDescStarter4Label: "Fréquence de mise à l'échelle",
    memberDescStarter4Value: '8 / 4 h',
    memberDescStarter5Label: "Amélioration de la qualité de l'image",
    memberDescStarter5Value: '2K',
    memberDescStarter6Label: 'Real-Time Design',
    memberDescStarter6Value: '1200 min / mo.',
    memberDescPlus0Label: 'Générations',
    memberDescPlus0Value: 'Illimité',
    memberDescPlus1Label: 'Vitesse de génération',
    memberDescPlus1Value: 'Fast',
    memberDescPlus2Label: 'Générations simultanées',
    memberDescPlus2Value: '{count}',
    memberDescPlus3Label: 'Fréquence de génération',
    memberDescPlus3Value: '150 / 4 h',
    memberDescPlus4Label: "Fréquence de mise à l'échelle",
    memberDescPlus4Value: '16 / 4 h',
    memberDescPlus5Label: "Amélioration de la qualité de l'image",
    memberDescPlus5Value: '3K',
    memberDescPlus6Label: 'Real-Time Design',
    memberDescPlus6Value: '3600 min / mo.',
    memberDescPro0Label: 'Générations',
    memberDescPro0Value: 'Illimité',
    memberDescPro1Label: 'Vitesse de génération',
    memberDescPro1Value: 'Turbo',
    memberDescPro2Label: 'Générations simultanées',
    memberDescPro2Value: '{count}',
    memberDescPro3Label: 'Fréquence de génération',
    memberDescPro3Value: 'Illimité',
    memberDescPro4Label: "Fréquence de mise à l'échelle",
    memberDescPro4Value: '48 / 4 h',
    memberDescPro5Label: "Amélioration de la qualité de l'image",
    memberDescPro5Value: '4K',
    memberDescPro6Label: 'Real-Time Design',
    memberDescPro6Value: 'Illimité',
    stripeConfirmMessage1: 'Traitement de la commande',
    stripeConfirmMessage2: "Veuillez confirmer si l'abonnement a réussi ?",
    stripeConfirmMessage3:
      'Pour vérifier que votre carte est valide, nous effectuerons une pré-autorisation de 1 {currency}.',
    stripeConfirmMessage4:
      "Cela sert uniquement à la vérification et <span style='font-weight: 600; color: #0d0d0d'>n'entraînera aucun frais réel</span>, soyez rassuré.",
    stripeSuccessMessage: 'Commande terminée !',
    stripeFailedMessage:
      'Échec de la vérification, veuillez réessayer ou utiliser un autre mode de paiement.',
    stripeConfirmButtonText: 'Abonnement terminé',
    stripeCancelButtonText: 'Annuler',
    stripeEditBillingMessage: "L'abonnement de facturation est en cours de modification...",
    stripeEditBillingConfirmButtonText: 'Compléter',
    stripeUpgradeMessage: 'Êtes-vous sûr de vouloir passer à un abonnement supérieur ?',
    stripeUpgradeSuccessMessage: 'Mise à niveau réussie !',
    stripeSubscribeRenewButtonText: 'Reprendre',
    stripeSubscribeRenewConfirmMessage: 'Êtes-vous sûr de vouloir reprendre le renouvellement ?',
    stripeSubscribeRenewSuccessMessage: 'Abonnement repris',
    stripeSubscribeCancelButtonText: 'Annuler',
    stripeSubscribeCancelConfirmMessage: 'Êtes-vous sûr de vouloir annuler le renouvellement ?',
    stripeSubscribeCancelSuccessMessage: 'Abonnement annulé',
    cancelQuestionaireTitle:
      'Veuillez sélectionner la raison de votre désabonnement (choix unique)',
    cancelQuestionaireSubject:
      'Veuillez choisir une des options suivantes (choix unique) pour nous aider à comprendre votre raison de vous désabonner.',
    cancelQuestionaireSelection1: "Je veux simplement annuler l'abonnement",
    cancelQuestionaireSelection2: 'Le prix est trop élevé',
    cancelQuestionaireSelection3: 'Le contenu du service ne correspond plus à mes besoins',
    cancelQuestionaireSelection4: 'Mauvaise expérience utilisateur',
    cancelQuestionaireSelection5:
      'Problèmes techniques (ex. : erreurs fréquentes ou interruptions)',
    cancelQuestionaireSelection6: "J'ai trouvé une meilleure alternative",
    cancelQuestionaireSelection7: 'Autre (veuillez préciser)',
    cancelQuestionaireSelection8: 'Les meilleurs',
    cancelQuestionaireSubmiteButtonText: 'Soumettre',
    cancelQuestionaireCancelButtonText: "Je l'utiliserai un peu plus",
    cancelSuccessMainTitle: 'Votre abonnement a été annulé',
    cancelSuccessSubject: 'Vous recevrez bientôt un e-mail de confirmation',
    reactivateTitle: "Vous n'aviez pas l'intention d'annuler ?",
    reactivateSubject: 'Pas de soucis, réactivons votre compte !',
    reactivateButtonText: 'Réactivez maintenant',
    upgradeTitle: 'Plan de mise à niveau',
    upgradeSubject: "Votre mise à niveau d'abonnement prendra effet immédiatement.",
    upgradeDesc:
      'Le coût sera proratisé en fonction des jours restants du mois en cours et déduit des frais du nouveau plan.',
    qrcodeTimeout: 'Code QR expiré',
    clickToRefresh: 'Cliquez pour réessayer',
    cycleText: 'Facturé mensuellement',
    yearlyText: 'Facturé annuellement',
    paymentTypeMonthlyText: 'Mensuel',
    paymentTypeYearlyText: 'Annuel',
    freeUsageText: "Reste de la génération gratuite aujourd'hui : {count}",
    currentSubscription: 'Abonnement actuel',
    expiredText: 'Renouveler: {date}'
  },
  similer: {
    similerTitle: 'Recherche visuelle',
    similerWaitingMessage: "Le composant est en cours d'initialisation, veuillez patienter",
    similerSearchFailedMessage: 'Recherche échouée, veuillez cliquer pour réessayer',
    similerNoSimilarMessage: 'Aucune image similaire trouvée',
    similerLoadingMoreDetailImageError:
      'Immagine en haute résolution non chargée, veuillez cliquer pour réessayer'
  },
  taskType: {
    generate: "Génération d'image",
    upscale: 'Upscale',
    realtimeDesign: 'Real-Time Design'
  },
  rewardTask: {
    rewardTaskListTitle1: "Obtenez 8 jours d'essai gratuit",
    rewardTaskListTitle1Intl: 'Essayer les fonctionnalités principales',
    rewardTaskListDesc1: 'Associer un téléphone',
    rewardTaskListGuide1: 'Associer un téléphone',
    rewardTaskListDesc2: 'Créer projet',
    rewardTaskListGuide2: 'Créer projet',
    rewardTaskListDesc3: 'Croquis vers Image',
    rewardTaskListGuide3:
      'Cliquez ou faites glisser pour télécharger des images afin de transformer des croquis, des dessins de style, des illustrations de mode et des photos réelles en effets réalistes.',
    rewardTaskListDesc4: 'Croquis vers Image (Correspondance de couleur)',
    rewardTaskListGuide4:
      'Dans Croquis vers Image, activer <span style="color: #4c4c4c; font-weight: 600; text-decoration-line: underline">Restauration des couleurs</span> <img src="{img}" style="vertical-align: middle;" /> fera référence aux couleurs d\'origine. Si désactivé, les couleurs seront générées aléatoirement.',
    rewardTaskListDesc5: 'Extension de style',
    rewardTaskListGuide5:
      "Dans l'Extension de style, l'IA peut rapidement créer une série de variations basées sur vos images de vêtements téléchargées.",
    rewardTaskListDesc6: 'Fusion de styles',
    rewardTaskListGuide6:
      "La Fusion de styles nécessite le téléchargement de deux images pour fusionner des vêtements avec des matériaux d'inspiration, créant une fusion de différents styles de mode.",
    rewardTaskListDesc7: 'Texte vers Image',
    rewardTaskListGuide7:
      'Entrez une description de votre design pour générer un LOOK. Vous pouvez utiliser <img src="{img}" style="vertical-align: middle; width: 13px; height: 13px;" /> Polissage IA et Description d\'image pour vous aider à rédiger les descriptions.',
    getRewardButtonText1: 'Terminé',
    sketchToImageInitPrompt:
      "Un beau mannequin porte une robe asymétrique à épaules dénudées avec une jupe ample aux grands plis et ondulations, et un tissu brillant. Associée à une paire d'escarpins pointus foncés, cette robe dégage élégance et modernité, avec un tissu légèrement métallique et brillant.",
    sketchToImageColorInitPrompt:
      "Photo de mode du mannequin portant une tenue élégante composée d'une longue jupe en lin gris argenté, un pull col roulé noir et un gilet à carreaux jaune chaud. La tenue comprend des bottes à semelles épaisses et une ceinture à carreaux jaune chaud et noire avec un grand nœud. Le gilet et la jupe sont décorés de motifs géométriques. Ses cheveux sont coiffés haut sur son front et elle porte des lunettes de soleil. Photo en pied.",
    styleExtensionInitPrompt:
      "Un vêtement haute couture présentant un blazer structuré et court avec des revers pointus et des détails de poches asymétriques, sur fond blanc. Le blazer est associé à une jupe drapée taille haute mettant en valeur des panneaux superposés et des ourlets fluides et asymétriques. Le design met l'accent sur une silhouette avant-gardiste avec un mélange de précision sur mesure et de drapé fluide. Le matériau semble être un tissu léger et mat, comme du coton ou un mélange de coton, lui donnant un aspect à la fois doux et structuré. La couleur vert terre atténuée renforce l'esthétique minimaliste et contemporaine. Le design global reflète un équilibre entre la coupe moderne et la fluidité artistique, parfait pour la mode de défilé ou éditoriale. photographie de produit, textures détaillées.",
    styleFusionInitPrompt:
      'Un pull coloré en grosse maille avec un motif de nœud tricoté en relief sur la poitrine, sur fond blanc.',
    text2ImageInitPrompt:
      "Un mannequin à la peau noire portant un blazer oversized et une jupe en cuir, de longues jambes dans des bottes avec un nœud géant à l'arrière des talons, posant pour une photo de mode Vogue sur fond blanc. L'image est hyperréaliste.",
    limitTime: 'Limité  ',
    guideStartButtonText: 'Générer',
    confirmCloseDialogTitle: 'Passer le tutoriel',
    confirmCloseDialogDesc:
      'Êtes-vous sûr de vouloir passer le tutoriel ? Vous ne pourrez plus le consulter ultérieurement.',
    confirmCloseDialogCancelButtonText: 'Annuler',
    confirmCloseDialogConfirmButtonText: 'Oui, passer',
    rewardTitle: 'Votre boost de design attend !',
    rewardDescription: 'Utilisez votre coupon et explorez les nouvelles fonctionnalités de design puissantes maintenant.',
    couponType1: 'Réduction',
    couponType2: 'Crédit',
    expiredText: 'Valable jusqu\'à: ',
    useNow: 'Utiliser maintenant !'
  },
  contextMenu: {
    copy: 'Copier',
    paste: 'Coller',
    selectAll: 'Tout sélectionner'
  },
  login: {
    success: 'Bonjour, Designer !',
    closeWindow: 'Vous vous êtes connecté avec succès. Vous pouvez fermer cette fenêtre.'
  },
  update: {
    updateDialogTitle: 'Mise à jour',
    updateDialogMessage: 'Une nouvelle version est disponible. Voulez-vous mettre à jour ?',
    updateDialogCurrentVersion: 'Version actuelle',
    updateDialogNewVersion: 'Nouvelle version',
    updateDialogCancelButtonText: 'Pas maintenant',
    updateDialogUpdateButtonText: 'Mettre à jour',
    updateDialogUpdateButtonLoadingText: 'Mise à jour...'
  },
  updateError: {
    updateErrorDialogTitle: 'Mise à jour',
    updateErrorDialogMessage: 'Une nouvelle version est disponible. Voulez-vous mettre à jour ?',
    updateErrorDialogButtonText: 'Mettre à jour'
  },
  updateProgress: {
    updateProgressDialogTitle: 'Mise à jour...'
  },
  remainingBalance: {
    realTimeDesign: 'Heures de design en temps réel',
    minute: 'minutes',
    hour: 'heures',
    frequency: 'Fréquence',
    upscale: 'Upscale',
    image: 'Images',
    last: 'Restantes',
    unlimited: 'Illimité'
  },
  compositor: {
    opacity: 'Opacité',
    saturation: 'Saturation',
    brightness: 'Luminosité',
    contrast: 'Contraste',
    hue: 'Teinte',
    depthMapFailed: 'Génération de la carte de profondeur échouée, veuillez réessayer'
  },
  coupon: {
    couponListTitle: 'Mes coupons',
    couponExpireCountdown: 'Temps restant: ',
    couponExpire: 'Valable jusqu\'à: ',
    couponListEmpty: 'Aucun coupon disponible',
    couponListEmptyDescription1: 'Rejoignez notre canal Discord officiel',
    couponListEmptyDescription2: 'Participer à des activités pour obtenir de grandes cadeaux !',
    couponListEmptyButton: 'Rejoignez Discord'
  },
  plugins: {
    pluginsTitle: 'Boutique de plugin',
    addPluginButtonText: 'PIN',
    removePluginButtonText: 'UNPIN',
    addedPluginButtonText: 'PINNED',
    noImages: 'Aucune image de plugin',
    noPluginComponentText:
      'Aucune page de plugin trouvée, veuillez vérifier si le plugin est correctement configuré',
    editPluginsButtonText: 'Modifier le plugin',
    editPluginsCompletedButtonText: 'Modifier terminé',
    morePluginsButtonText: 'Plus de plugins',
    removePluginTipsTitle: 'Supprimer le plugin',
    removePluginTips1: 'Le plugin peut être ajouté à nouveau depuis',
    removePluginTips2: '<span style="color: #0d0d0d; font-weight: 600;">Boutique de plugins</span>',
    pluginDisabled: 'Plugin non disponible',
    pluginsTips: {
      title: 'LOOK AI',
      subtitle: 'Boutique de plugin disponible !',
      plugintipTitle1: 'Outils tout-en-un :',
      plugintipDesc1:
        'Découvrez notre nouvelle Boutique de plugins ! Nous avons regroupé toutes vos fonctionnalités préférées - Recolorisation intelligente, Changement de scène IA, Effacement magique, Détourage en un clic, et plus encore - en un seul endroit pratique. Il suffit de les épingler, et elles sont de retour en action !',
      plugintipTitle2: 'Personnalisez votre espace de travail :',
      plugintipDesc2:
        "Allez dans la Boutique de plugins > Ajouter des plugins > Cliquez sur 'Modifier les plugins' dans la barre d'outils de gauche, puis faites glisser et arrangez les icônes comme vous le souhaitez ! Votre LOOK, vos règles !",
      plugintipTitle3: 'Plus de plugins à venir !',
      plugintipDesc3:
        'Vous avez des idées ? Dites-nous quels nouveaux outils vous aimeriez, ou partagez vos commentaires. LOOK est conçu pour vous, et nous sommes à votre écoute !'
    },
    pluginsTipsFooter: {
      discord: 'Rejoignez notre communauté Discord',
      instagram: 'Voir plus sur Instagram',
      email: 'Envoyer un email : {email}'
    }
  }
}

export default fr as any
